import {alpha, SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const wrapperSx: SxProps<Theme> = {
    background: theme.palette.background.default,
    border: `1px solid ${theme.palette.neutral[100]}`,
    borderRadius: theme.spacing(12 / 8),
    padding: theme.spacing(14 / 8, 16 / 8),
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: theme.spacing(6 / 8),
    transition: 'transform .18s ease, box-shadow .18s ease, border-color .18s ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: `0 8px 24px ${alpha(theme.palette.neutral[900], 0.06)}`,
        borderColor: theme.palette.neutral[200],
    },
};

export const headerSx: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(10 / 8),
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: theme.spacing(8 / 8),
    },
};

export const titleWrapSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(10 / 8),
    flexShrink: 0,
    minWidth: 0,
    maxWidth: '45%',
    [theme.breakpoints.down('lg')]: {
        maxWidth: '100%',
        pr: '2.5rem',
    },
};

export const badgeSx: SxProps<Theme> = {
    flexShrink: 0,
    width: 36,
    height: 36,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.main,
    background: alpha(theme.palette.primary.main, 0.1),
};

export const titleSx: SxProps<Theme> = {
    fontWeight: 600,
    lineHeight: 1.3,
    color: theme.palette.neutral[900],
    wordBreak: 'break-word',
};

export const actionsSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(6 / 8),
    flex: 1,
    minWidth: 0,
    justifyContent: 'flex-end',
    [theme.breakpoints.down('lg')]: {
        width: '100%',
        flex: 'unset',
        justifyContent: 'flex-start',
    },
};

export const valuePillSx: SxProps<Theme> = {
    display: 'inline-block',
    maxWidth: '100%',
    padding: theme.spacing(4 / 8, 10 / 8),
    borderRadius: theme.spacing(8 / 8),
    background: theme.palette.neutral[50],
    border: `1px solid ${theme.palette.neutral[100]}`,
    color: theme.palette.neutral[800],
    fontFamily: 'monospace',
    fontSize: '0.8125rem',
    lineHeight: 1.5,
    textAlign: 'left',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
};

export const booleanPillSx = (isTrue: boolean): SxProps<Theme> => ({
    display: 'inline-block',
    flexShrink: 0,
    padding: theme.spacing(4 / 8, 12 / 8),
    borderRadius: 999,
    fontSize: '0.8125rem',
    fontWeight: 600,
    lineHeight: 1.6,
    whiteSpace: 'nowrap',
    color: isTrue ? theme.palette.primary.dark : theme.palette.brand.dark,
    background: alpha(isTrue ? theme.palette.primary.main : theme.palette.brand.main, 0.12),
});

export const editButtonSx: SxProps<Theme> = {
    flexShrink: 0,
    background: 'transparent',
    transition: 'background .18s ease',
    '&:hover': {
        background: alpha(theme.palette.primary.main, 0.1),
    },
    [theme.breakpoints.down('lg')]: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
};

export const descriptionSx: SxProps<Theme> = {
    color: theme.palette.neutral[500],
    fontSize: '0.875rem',
    lineHeight: 1.45,
    [theme.breakpoints.up('lg')]: {
        pl: theme.spacing(46 / 8),
    },
};

export const formWrapperSx: SxProps<Theme> = {
    '& .MuiPaper-root': {
        maxWidth: theme.spacing(200 / 8),
        width: '100%',
    },
};